import OrderHistorySection from "../OrderHistorySection";

const OrderManagement = (props) => {
  const {
    todaysOrders,
    processedPreviousOrders,
    orderColumns,
    today_page,
    today_total,
    today_per_page,
    change_today_pagination,
    spinnerLoading,
    newAntIcon,
    onViewOrder,
    activeTab,
    setActiveTab,
  } = props;

  return (
    <>
      <OrderHistorySection
        todaysOrders={todaysOrders}
        processedPreviousOrders={processedPreviousOrders}
        orderColumns={orderColumns}
        today_page={today_page}
        today_total={today_total}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        today_per_page={today_per_page}
        change_today_pagination={change_today_pagination}
        handleViewClick={onViewOrder}
        spinnerLoading={spinnerLoading}
        newAntIcon={newAntIcon}
      />
    </>
  );
};

export default OrderManagement;
